"use client";
import { ButtonBase } from "@mui/material";

import ToolTip from "../Tooltip";
import { _Icon } from "./index";

const ButtonOutlined = ({
  selected,
  IconStart,
  IconEnd,
  tooltip,
  label = "",
  fullWidth,
  iconColor,
  color = "var(--primary-color)",
  size = "medium",
  disabled = false,
  sx = {},
  ...props
}) => (
  <ToolTip title={tooltip} sx={fullWidth ? { width: "100%" } : undefined}>
    <ButtonBase
      disabled={disabled}
      sx={theme => ({
        px: 3,
        border: "1px solid",
        width: fullWidth ? "100%" : undefined,
        borderColor: disabled
          ? theme.addAlpha("var(--surface-on-color)", 0.12)
          : "var(--outline-color)",
        borderRadius: "var(--shape-round)",
        height: size === "small" ? 32 : 40,
        transition: "var(--transition-all)",
        typography: {
          compact: "labelMd",
          expanded: `label${size === "small" ? "Md" : "Lg"}`
        },
        color: disabled
          ? theme.addAlpha("var(--surface-on-color)", 0.38)
          : color,
        "&:hover": {
          backgroundImage: disabled
            ? undefined
            : `linear-gradient(${theme.addAlpha(
                "var(--secondary-on-container)",
                0.08
              )}, ${theme.addAlpha("var(--secondary-on-container)", 0.08)})`
        },
        ...sx
      })}
      {...props}
    >
      {IconStart ? (
        <_Icon Icon={IconStart} disabled={disabled} color={iconColor} />
      ) : null}
      {label}
      {IconEnd ? (
        <_Icon end Icon={IconEnd} disabled={disabled} color={iconColor} />
      ) : null}
    </ButtonBase>
  </ToolTip>
);

export default ButtonOutlined;
